module.exports = __webpack_public_path__ + "img/gallery-7.bfc6087c.png";